import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Funciona si mi migraña es hereditaria?',
  a: 'Sí, el método actúa sobre la respuesta física del nervio, independientemente del origen.'
}, {
  q: '¿Necesito comprar equipo caro?',
  a: 'No, el 90% de las herramientas ya las tienes en tu cocina o en tu oficina.'
}, {
  q: '¿Es seguro si estoy tomando otros medicamentos?',
  a: 'Sí, es una técnica externa y física que no interfiere con tratamientos químicos.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-6 bg-navy-800" data-id="element-27">
      <div className="max-w-3xl mx-auto" data-id="element-28">
        <FadeIn data-id="element-29">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-30">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-31">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-32">
              <div className={`border rounded-xl overflow-hidden transition-colors ${openIndex === index ? 'border-teal-500/50 bg-navy-900' : 'border-slate-700 bg-navy-900/50'}`} data-id="element-33">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-34">
                  <span className="font-medium text-white pr-4" data-id="element-35">{faq.q}</span>
                  <ChevronDownIcon className={`w-5 h-5 text-teal-500 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-36" />
                </button>

                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-37">
                  <p className="text-slate-400" data-id="element-38">{faq.a}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}